import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Box, Center, Image, Text } from '@chakra-ui/react';
import { ContainerProps } from '../common/container';
import { useGetDynamicLink } from '../api/dynamicLinks';
import AppImage from '../assets/push-training-app.png';
import DownloadOnTheAppStoreImage from '../assets/download-on-the-app-store.svg';

const DynamicLinkPage = observer(() => {
  const { shortPath } = useParams();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [searchParams, setSearchParams] = useSearchParams();
  const shouldRedirect = searchParams.get('r') !== '0';
  const { getDynamicLink, isLoading, error } = useGetDynamicLink();
  const [destinationUrl, setDestinationUrl] = useState<string | null>(null);

  useEffect(() => {
    if (shortPath) {
      getDynamicLink(shortPath, window.screen.width, window.screen.height).then(
        (result) => {
          if (result) {
            setDestinationUrl(result.dynamicLink.destinationUrl);
            if (shouldRedirect) {
              window.location.href = result.dynamicLink.destinationUrl;
            }
          }
        },
      );
    }
  }, []);

  useEffect(() => {
    if (error) {
      window.location.href = '/download';
    }
  }, [error]);

  if (!shouldRedirect) {
    return <FullScreenAppStoreCTA href={destinationUrl ?? '/download'} />;
  }

  if (isLoading) {
    return <FullScreenContainer>Loading...</FullScreenContainer>;
  }
  if (destinationUrl) {
    return <FullScreenContainer>Redirecting...</FullScreenContainer>;
  }
  if (error) {
    return <FullScreenContainer>{error}</FullScreenContainer>;
  }
  return <></>;
});

const FullScreenAppStoreCTA = ({ href }: { href: string }) => {
  return (
    <a href={href}>
      <FullScreenContainer>
        <Center flexDirection={'column'}>
          <Image
            src={AppImage}
            borderRadius={'2xl'}
            width={'76px'}
            backgroundColor={'dripSecondaryFill'}
            marginTop={'15vh'}
          ></Image>
          <Text marginTop={'2vh'} fontWeight={'bold'}>
            Treadmill Workout Push Training
          </Text>
          <Text>Get the app to continue</Text>
          <Image
            src={DownloadOnTheAppStoreImage}
            alt="Download on the App Store"
            width={'120px'}
            marginTop={'2vh'}
          ></Image>
        </Center>
      </FullScreenContainer>
    </a>
  );
};

const FullScreenContainer = ({ children }: ContainerProps) => {
  return (
    <Box
      width={'100vw'}
      height={'100vh'}
      backgroundColor={'#FFFFFF'}
      color={'#000000'}
    >
      {children}
    </Box>
  );
};

export default DynamicLinkPage;
